<template>
  <v-content>
    <v-responsive
      class="white--text"
      style="background: linear-gradient(to bottom, #1976d2, #5CBBF6)"
    >
      <v-container>
        <v-layout
          align-center
          justify-center
          wrap
        >
          <div class="text-xs-center text-lg-left">
            <h1
              :class="'display-2'"
              class="my-5"
            >
              脱出メイト
            </h1>
            <p
              :class="'display-1'"
              class="my-4"
            >
              脱出履歴を記録して共有しよう。
            </p>
            <v-layout
              justify-center
              wrap
            >
              <v-btn
                class="primary--text ml-0 mb-4"
                color="white"
                large
                to="/sign"
                block
              >
                はじめる
              </v-btn>
            </v-layout>
          </div>
        </v-layout>
      </v-container>
    </v-responsive>
    <v-container grid-list-lg>
      <h2>特徴</h2>
      <v-layout
        row
        wrap
      >
        <v-flex
          v-for="feature in features"
          :key="feature.title"
          d-flex
          xs12
          md6
        >
          <v-card
            color="grey lighten-2"
          >
            <v-card-title
              primary
              class="title"
            >
              {{ feature.title }}
            </v-card-title>
            <v-card-text>
              {{ feature.description }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
      return {
        features: [
          {title:"必要なものはTwitterアカウントのみ", description:"メールアドレスを登録する必要がありません。Twitterのアカウントさえあれば利用できます。"},
          {title:"お好きなデバイスで操作", description:"スマートフォン、タブレット、PCからすべての操作が可能です。"},
          {title:"簡単に共有", description:"マイページから脱出記録を簡単に共有できます。"},
          {title:"仲間を募集（仮）", description:"行きたい脱出ゲームに一緒に参加することができます。"},
        ],
      };
    },
  computed: {
    authenticated: function() {
      return this.$auth.isAuthenticated()
    },
  },
  methods: {
    authenticate: function (provider) {
      this.$auth.authenticate(provider).then((res) => {
        const userId = res.data.ID
        this.$router.push({ path: `/users/${userId}/edit`})
      })
    }
  }
}
</script>
